module.exports = __webpack_public_path__ + "img/itsu-pattern.69d6236.svg";